module.exports = __webpack_public_path__ + "img/logoNiCircle.3e55865d.png";